import React from "react";
import { Link } from "react-router-dom";
import WKnowlegeImg from "../Assets/img/web-knowledge/w-knowledge-img.svg";

const KnowledgeBaseTicket = () => {
  return (
    <>
      <section className="knowledge-ticket-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="knowledge-ticket-content">
                <h3 className="kn-title">
                  Looking for Help? Submit a Ticket Now
                </h3>
                <p>
                  Couldn’t find what your are looking for ? Submit a ticket and
                  let us help you.
                </p>
                <div className="knowledge-ticket-btn blog-btn">
                  <Link href="#" className="theme-btn primary">
                    <i className="icofont-arrow-right"></i>Submit ticket
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="knowledge-ticket-img">
                <img src={WKnowlegeImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KnowledgeBaseTicket;
